module.exports = __webpack_public_path__ + "img/canvas.3cc43df0.svg";